import React from "react";
import { Text } from "style/v2/components/Typography";
import { AssetCell, AssetLogo } from "../TopHoldings/TopHoldings.styles";

const formatPercent = (value) => {
  if (value == null || isNaN(value)) return "--";
  return `${(value * 100).toFixed(2)}%`;
};

export const columns = [
  {
    dataField: "asset",
    text: "Asset",
    props: {
      cell: ({ row }) => (
        <AssetCell>
          <AssetLogo
            src={row.original.asset.imageUrl}
            alt={row.original.asset.symbol}
          />
          <Text variant="bodyMedium" weight="600">
            {row.original.asset.symbol}
          </Text>
        </AssetCell>
      ),
    },
  },
  {
    dataField: "holdings30d",
    text: "30 Day",
    props: {
      cell: ({ getValue }) => (
        <Text variant="bodyMedium" color="secondary">
          {formatPercent(getValue())}
        </Text>
      ),
    },
  },
  {
    dataField: "holdingsAverage",
    text: "Average",
    props: {
      cell: ({ getValue }) => (
        <Text variant="bodyMedium" color="secondary">
          {formatPercent(getValue())}
        </Text>
      ),
    },
  },
  {
    dataField: "holdingsCurrent",
    text: "Current",
    props: {
      cell: ({ getValue }) => (
        <Text variant="bodyMedium" color="secondary">
          {formatPercent(getValue())}
        </Text>
      ),
    },
  },
];
